import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Flex, Button, message, Card, Skeleton, Checkbox } from 'antd';

import { Semester } from './components/Semester';
import { CustomDatePicker } from '../../../../components/CustomDatePicker';

import apis from '../../../../services/Apis';

import { table } from './struct';
import { getRandomId } from '../../../../utilities/randomId';
import usePlanning from '../../../../hooks/usePlanning';

// const { Title } = Typography;

const Plan11 = ({ currentApas, tableNo, childToParent }) => {
    const apa = currentApas.find((item) => item.form_no === tableNo);

    const [messageApi, contextHolder] = message.useMessage();

    const user = useSelector((state) => state.user);
    const { userDetails } = user;

    const currentDate = new Date();
    const currentYear = currentDate.getFullYear() - 1;
    const [selectedYear, setSelectedYear] = useState(Number(currentYear));
    const handleSelectedYear = (_, yearString) =>
        setSelectedYear(Number(yearString));

    const {
        planing,
        updated,
        fetchLoading,
        updateLoading,
        updatePlaning,
        handlePlaning,
        noPlanning,
        handleNoPlanning,
        maxEstimatedPoint
    } = usePlanning({
        url: apis.PLANING,
        formId: apa?.id,
        userDetails: userDetails.user_id,
        selectedYear: selectedYear,
        messageApi: messageApi
    });

    const hasUnselectedSemester = planing?.some((item) => item?.tempSemester);

    const handleSave = () => {
        if (hasUnselectedSemester) {
            messageApi.error('Please select a semester before saving');
            return;
        }
        updatePlaning();
    };

    useEffect(() => {
        childToParent(maxEstimatedPoint);
    }, [maxEstimatedPoint]);

    const handleOnCheck = (e) => {
        handleNoPlanning(e.target.checked);
    };

    const removeSemester = (semester) =>
        handlePlaning(planing.filter((item) => item.semester !== semester));

    // Each semester carries BOTH tables inline: { teaching: [...], supervision: [...] }
    const addSemester = () =>
        handlePlaning([
            ...planing,
            {
                semester: '',
                tempSemester: getRandomId(),
                teaching: [],
                supervision: []
            }
        ]);

    const setSemesterName = (semesterName, id) => {
        const duplicate = planing.some((item) => item.semester === semesterName);
        if (duplicate) {
            messageApi.error('Can not create duplicate semester');
            return;
        }

        handlePlaning(
            planing.map((item) =>
                item.tempSemester === id
                    ? {
                        ...item,
                        tempSemester: null,
                        semester: semesterName,
                        teaching: item.teaching || [],
                        supervision: item.supervision || []
                    }
                    : item
            )
        );
    };

    // Table A ~ Teaching Evaluation
    const updateTeaching = (semesterName, teaching) => {
        handlePlaning(
            planing.map((item) =>
                item.semester === semesterName ? { ...item, teaching } : item
            )
        );
    };

    // Table B ~ Supervision
    const updateSupervision = (semesterName, supervision) => {
        handlePlaning(
            planing.map((item) =>
                item.semester === semesterName ? { ...item, supervision } : item
            )
        );
    };

    return (
        <Card {...table.wrapper}>
            {contextHolder}
            {/* <Title level={5}>{title ? title : ''}</Title> */}
            <br />
            <Flex {...table.header}>
                <CustomDatePicker
                    selectedYear={selectedYear}
                    handleSelectedYear={handleSelectedYear}
                />
            </Flex>
            <br />
            {planing && !fetchLoading ? (
                planing.map((semester) => (
                    <React.Fragment key={semester.tempSemester || semester.semester}>
                        <Semester
                            semesterDetail={semester}
                            teaching={semester.teaching || []}
                            supervision={semester.supervision || []}
                            removeSemester={removeSemester}
                            setSemesterName={setSemesterName}
                            updateTeaching={updateTeaching}
                            updateSupervision={updateSupervision}
                        />
                        <br />
                    </React.Fragment>
                ))
            ) : (
                <Skeleton loading={fetchLoading} active />
            )}

            <Flex {...table.header}>
                <Button
                    {...table.addSemesterButton}
                    disabled={planing?.length >= 3}
                    onClick={() => addSemester()}
                >
                    Add New Semester
                </Button>
                {updated ? (
                    <Button
                        {...table.saveButton}
                        loading={updateLoading}
                        disabled={hasUnselectedSemester}
                        onClick={handleSave}
                    >
                        Save
                    </Button>
                ) : (
                    <></>
                )}
            </Flex>
            <br />
            <Flex>
                <Checkbox checked={noPlanning} onChange={handleOnCheck}>
                    I am not planning to do anything associated with this module
                </Checkbox>
            </Flex>
        </Card>
    );
};

export default Plan11;